<ng-container *ngIf="viewModel$ | async as vm">
  <app-dashboard-shell
    [lastReload]="vm.lastReload"
    [loading]="vm.loading"
    [showRefresh]="true"
    (refresh)="triggerReload()"
  >
    <ng-container filters>
      <div class="dropdowns">
        <p-dropdown
          [ngModel]="vm.status"
          (ngModelChange)="setStatus($event)"
          appendTo="body"
          [options]="statusOptions"
        >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-filter"></i>
              <span>
                Status: {{ vm.status }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          [ngModel]="vm.anchor"
          (ngModelChange)="setAnchor($event)"
          appendTo="body"
          [options]="anchorOptions"
        >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-map-marker"></i>
              <span>
                Anchor Point: {{ vm.anchor }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </ng-container>

    <div class="p-col-12" *ngIf="vm.showGatewayBanner">
      <p-messages severity="warn" [closable]="false">
        <ng-template pTemplate>
          <div class="gateway-banner">
            <span>
              <strong>No payment gateway is set up for this zone.</strong>
              Connect BlueSage to take card payments and see processing fees and tips here.
              <ng-container *ngIf="!vm.canConfigureGateway">Ask an admin to set it up.</ng-container>
            </span>
            <button
              *ngIf="vm.canConfigureGateway"
              pButton
              type="button"
              label="Set up BlueSage"
              icon="pi pi-arrow-right"
              iconPos="right"
              class="p-button-sm"
              routerLink="/business/payment"
            ></button>
          </div>
        </ng-template>
      </p-messages>
    </div>

    <div class="p-col-12">
      <app-transactions-activity></app-transactions-activity>
    </div>

    <div class="p-col-12">
      <div class="dashboard-card">
        <div class="dashboard-card-header p-mb-3">
          <div class="title-row">
            <h4 class="p-mb-0">
              Payments<app-error-icon
                *ngIf="vm.error"
                [error]="vm.error"
              ></app-error-icon>
            </h4>
            <app-dashboard-info-v2>
              <div class="p-mb-2">
                Payments in the selected period, with the card differential and any tip recorded by the payment provider.
              </div>
              <div class="p-mb-2">
                <a
                  [routerLink]="['/reports', 'dynamic', 'new']"
                  [queryParams]="vm.queryParams"
                  target="_blank"
                  >View Report</a
                >.
              </div>
            </app-dashboard-info-v2>
          </div>
        </div>

        <p-blockUI
          [target]="transactionsTable"
          [blocked]="vm.loading"
          [autoZIndex]="false"
        >
          <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
        </p-blockUI>

        <app-blockable #transactionsTable>
          <div class="table-scroll" *ngIf="!vm.isEmpty">
            <table class="transactions-table">
              <thead>
                <tr>
                  <th
                    *ngFor="let header of vm.headers"
                    [class.numeric]="header.numeric"
                  >{{ header.text }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of vm.rows">
                  <td
                    *ngFor="let cell of row"
                    [class.numeric]="cell.numeric"
                  >
                    <span
                      *ngIf="cell.routerLink; else plainCell"
                      class="freya-link-button"
                      [routerLink]="cell.routerLink"
                      [queryParams]="cell.queryParams"
                    >{{ cell.text }}</span>
                    <ng-template #plainCell>{{ cell.text }}</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-dashboard-empty-state
            *ngIf="vm.isEmpty"
            text="No payments in the selected period"
          ></app-dashboard-empty-state>
        </app-blockable>
      </div>
    </div>
  </app-dashboard-shell>
</ng-container>
